import { Link } from "react-router-dom";

function LoginOrRegisterBanner() {
  return (
    <>
      <div className="sellArtworks text-white">
        <div className="d-md-flex gap-5 justify-content-between align-items-center">
          <div>
            <h2>Take the First Step Towards Selling Your Art!</h2>
            <p>
              Join a community of artists selling their work to passionate
              buyers. Simply register and get verified to showcase your
              creations to enthusiastic buyers.
            </p>
          </div>
          <Link className="mt-md-0 mt-3" to="/login">
            Register / Login
          </Link>
        </div>
      </div>
    </>
  );
}

export default LoginOrRegisterBanner;
